import { Icons } from 'components';

import makeStyles from '@mui/styles/makeStyles';

import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  CircularProgress,
} from '@mui/material';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import ShareSerives from 'utility/ShareServices';
const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  dialogTitle: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  timeLineBox: {
    height: '50px',
    padding: '50px 0',
    width: '100%',
    position: 'relative',
  },

  timestamp: {
    margin: 'auto',
    marginBottom: '5px',
    padding: '0px 4px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '10px',
  },

  timeLineStatus: {
    padding: '0px 10px',
    display: 'flex',
    justifyContent: 'end',
    //borderTop: '3px solid #ccc',
    position: 'relative',
    transition: 'all 200ms ease-in',
    margin: '0 4px',
  },
  swiperSlide: {
    textAlign: 'center',
    fontSize: '12px',
    width: '200px',
    height: '100%',
    position: 'relative',
  },
  swiperContainer: {
    width: '96%',
    margin: 'auto',
    overflowY: 'hidden',
    display: 'flex',
  },

  swiperWrapper: {
    display: 'inline-flex',
    flexDirection: 'row',
    overflowY: 'auto',
    justifyContent: 'center',
  },

  badgPrimary: {
    backgroundColor: '#2B3990',
    padding: '0 4px',
    borderRadius: '20px',
    color: 'white',
  },
  badgFaild: {
    backgroundColor: 'red',
    padding: '0 4px',
    borderRadius: '20px',
    color: 'white',
    minWidth: '50px',
  },

  isLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '16px 0',
  },
  isError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    margin: '16px 0',
  },

  fileTitle: {
    display: 'flex',
    position: 'absolute',
    top: '10px',
    left: '12px',
    color: '#ccc',
    fontSize: '12px',
  },
  statusTitle: {
    position: 'absolute',
    bottom: '-8px',
    right: '30px',
    fontSize: '12px',
    color: '#ccc',
  },
  activeColor: {
    borderTop: '3px solid #2B3990',
  },
  grayColor: {
    borderTop: '3px solid #ccc',
  },
  successColor: {
    borderTop: '3px solid green',
  },
  faildColor: {
    borderTop: '3px solid red',
  },
}));
const TimelineDg = (props) => {
  const { isOpenTimetDG, setIsOpenTimetDG, reportKey } = props;
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [length, setLength] = useState(0);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    isOpenTimetDG && getDataTimeLine();
    !isOpenTimetDG && resetData();
  }, [isOpenTimetDG]);

  const getDataTimeLine = () => {
    setIsLoading(true);
    let params = {
      reportStatusKeys: ['TO_DO', 'DOING'],
      reportKeys: reportKey,
    };
    reportKey == 'all' && delete params['reportKeys'];
    ShareSerives.getRportOfflineRequest(params)
      .then((res) => {
        setData(res?.result || []);
        setLength(res?.count || 0);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
      });
  };
  const resetData = () => {
    setTimeout(() => {
      setIsError(false);
      setData([]);
      setLength(0);
    }, 500);
  };

  const convertDate = (date) => {
    return String(date).split(' ')[0];
  };

  const ShpeTimeLineItem = (item) => {
    const badg = {
      primary: classes.badgPrimary,
      faild: classes.badgFaild,
    };
    const lastStatus = {
      DONE: classes.badgPrimary,
      FAILED: classes.badgFaild,
    };
    const status = item['status-key'];
    const colors = checkColor(item);
    return (
      <section className={classes.timeLineBox}>
        {/* <span className={classes.fileTitle}>{item['report-name']}{item['persian-request-date'] ? `(${convertDate(item['persian-request-date'])})` : ''}</span> */}
        <div className={classes.fileTitle}>
          <span>{item['report-name']}</span>
          <span>
            {item['persian-request-date'] ? `(${convertDate(item['persian-request-date'])})` : ''}
          </span>
        </div>
        <div className={classes.swiperContainer}>
          <div className={classes.swiperWrapper}>
            <div className={classes.swiperSlide}>
              <div className={classes.timestamp}>
                <span className={status == 'TO_DO' && badg.primary}>در انتظار پردازش</span>
              </div>
              <div className={clsx(classes.timeLineStatus, colors.todoStep)}>
                <span className={classes.statusPoint}></span>
              </div>
            </div>
            <div className={classes.swiperSlide}>
              <div className={classes.timestamp}>
                <span className={status == 'DOING' && badg.primary}>در حال پردازش</span>
              </div>
              <div className={clsx(classes.timeLineStatus, colors.doingStep)}>
                <span className={classes.statusPoint}></span>
              </div>
            </div>
            <div className={classes.swiperSlide}>
              <div className={classes.timestamp}>
                <span className={lastStatus[status]}>
                  {status == 'FAILED' ? 'خطا' : 'پردازش شده'}
                </span>
              </div>
              <div className={clsx(classes.timeLineStatus, colors.doneStep)}>
                <span className={classes.statusPoint}></span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const checkColor = (item) => {
    let colors;
    if (item['status-key'] == 'TO_DO') {
      // در انتظار پردازش
      colors = {
        todoStep: classes.activeColor,
        doingStep: classes.grayColor,
        doneStep: classes.grayColor,
      };
    } else if (item['status-key'] == 'DOING') {
      // در حال پردازش
      colors = {
        todoStep: classes.grayColor,
        doingStep: classes.activeColor,
        doneStep: classes.grayColor,
      };
    } else if (item['status-key'] == 'DONE') {
      // پردازش شده
      colors = {
        todoStep: classes.grayColor,
        doingStep: classes.grayColor,
        doneStep: classes.successColor,
      };
    } else {
      // faild
      colors = {
        todoStep: classes.grayColor,
        doingStep: classes.grayColor,
        doneStep: classes.faildColor,
      };
    }
    return colors;
  };

  return (
    <>
      <Dialog
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="xs"
        open={isOpenTimetDG}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setIsOpenTimetDG(false)}
          className={classes.dialogTitle}
        >
          {length ? ` در حال آماده سازی فایل (${length})` : ' در حال آماده سازی فایل'}
          {/* {row.thingUserId} */}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setIsOpenTimetDG(false)}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          {data && data.length ? data.map((item, index) => ShpeTimeLineItem(item)) : null}

          {isLoading && (
            <div className={classes.isLoading}>
              <CircularProgress size={24} />
            </div>
          )}
          {isError && isLoading == false && (
            <div className={classes.isError}>اطلاعاتی یافت نشد</div>
          )}
          {!data.length && isLoading == false && !isError && (
            <div className={classes.isError}>اطلاعاتی یافت نشد</div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TimelineDg;
